module.exports = __webpack_public_path__ + "static/media/Google Pixel 4 XL Oh So Orange.ef7e2a02.png";